var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMegaphoneCampanha(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.319,
    height: 33.456,
    viewBox: "0 0 34.319 33.456",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_930",
    "data-name": "Caminho 930",
    d: "M8.544,34.358V25.633H6.363a4.2,4.2,0,0,1-3.08-1.283A4.2,4.2,0,0,1,2,21.27V16.907a4.2,4.2,0,0,1,1.283-3.082,4.2,4.2,0,0,1,3.08-1.28h8.726L26,6V32.177L15.088,25.633H12.907v8.726ZM28.177,26.4V11.781A9.96,9.96,0,0,1,30.55,14.97a9.425,9.425,0,0,1,.9,4.118,9.415,9.415,0,0,1-.9,4.116A9.969,9.969,0,0,1,28.177,26.4Z",
    transform: "translate(-3.108 0.111) rotate(-11)",
    fill: "#feac0e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMegaphoneCampanha);
export default __webpack_public_path__ + "static/media/icon_megaphone_campanha.969eb8e94209bb8c83558eca529365dd.svg";
export { ForwardRef as ReactComponent };